import { Pipe, PipeTransform } from '@angular/core';
import { PlanMetadata } from 'fitforce-document-sync';

@Pipe({
  name: 'filterPlans'
})
export class FilterPlansPipe implements PipeTransform {

  transform(plans: (PlanMetadata)[], searchText: string): any {
  if (searchText === undefined) { return plans; }

  return plans.filter(function (plan) {
    return plan.name.toLowerCase().indexOf(searchText.toLowerCase()) > -1;
  });
}

}
